import { ChangeEventHandler, MouseEventHandler } from "react";
import TextArea from "@ingka/text-area";
import { CSSProperties } from "styled-components";

import "@ingka/forms/dist/style.css";

interface TextAreaProps {
  id?: string;
  autoFocus?: boolean;
  label: string;
  "aria-label"?: string;
  value: string;
  readOnly?: boolean;
  onChange?: ChangeEventHandler<HTMLTextAreaElement>;
  onKeyDown?: (object: any) => void;
  style?: CSSProperties;
  onClick?: MouseEventHandler<HTMLTextAreaElement>;
  rows?: number | undefined;
  disabled?: boolean;
  "data-testid"?: string;
  className?: string;
}

export const FixaTextArea = (props: TextAreaProps) => {
  // Skapa sets a fixed height for the TextArea component. Override minHeight when rows is explicitly set to a value other than the default (3).
  const styleOverrides = { ...(props.style ?? {}) };
  const rows = props.rows ?? 3;
  if (rows !== 3) styleOverrides.minHeight = "auto";
  return <TextArea {...props} style={styleOverrides} />;
};
